import { render, staticRenderFns } from "./RegTan.vue?vue&type=template&id=aea1abdc&scoped=true"
import script from "./RegTan.vue?vue&type=script&lang=js"
export * from "./RegTan.vue?vue&type=script&lang=js"
import style0 from "./RegTan.vue?vue&type=style&index=0&id=aea1abdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea1abdc",
  null
  
)

export default component.exports